// import AsyncCreateableSelect from "./AsyncCreatableSelect";
import Select from "./Select";
import { useCollection } from "@nandorojo/swr-firestore";
import { countries } from "country-data";
import { Loader } from 'react-bulma-components'

const CitySelect = ({ values, isCreatable = false, setValues, ...props }) => {
  const citiesData = useCollection("cities", {
    orderBy: [
      ["country", "asc"],
      ["city", "asc"]
    ]
  });
  if (citiesData.error) {
    return <p>{citiesData.error}</p>;
    console.error(citiesData.error);
  }
  const cityOptions = citiesData?.data?.map(city => {
    const country = countries[city.country];
    return {
      label: `${city.city}, ${country.name} ${country.emoji && country.emoji}`,
      value: city
    };
  });
  return (
    citiesData.loading ?
      (
        <Loader />
      ) : (
        <Select
          setFieldValue={(__, city) => {
            setValues({
              ...values,
              [props.name]: city,
              city: city?.city,
              country: city?.country
            });
            // setFieldValue(props.name, city);
            // if (city) {
            //   setFieldValue("city", city.city);
            //   setFieldValue("country", city.country);
            // } else {
            //   setFieldValue("city", null);
            //   setFieldValue("country", null);
            // }
          }}
          options={cityOptions}
          isMulti={false}
          isCreatable={isCreatable}
          {...props}
        />
      )
  );
}
export default CitySelect;
